import { ajax } from '../../../services/helper'
class ApiService {

    getEntityStatusData = (type) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/entityStatus/list?type="+type
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    addEntityStatus = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/entityStatus/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getEntityStatusById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/entityStatus/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     editEntityStatus = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/entityStatus/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getcostCenterDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/costCenters/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }    

    getEmployeesListData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }    

    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Entity Status/services/apiservices.js